<div class="card card-wider card-cascade">
    <div class="view gradient-card-header primary-gradient white-text">
        <h3 class='h3-responsive text-center'>{{title}}</h3>
    </div>
    <div class="card-body">
        <div class='row'>
            <div class='col' *ngIf="description" [innerHTML]="description"></div>
        </div>
        <div *ngFor="let section of sections" class="row d-print-block-visible">
            <div class="col-12 d-print-block-visible">
                <!-- two-column template -->
                <div *ngIf="section.template == 'two-column'" class="row mb-3 section section-two-column" [ngClass]="getPrintClasses(section)">
                    <dac-summary-section-graph-item *ngFor="let item of section.components" class="col-6" [item]="item" [assessmentResult]="getAssessmentResult(item.data.assessmentUid)"
                        [scaleResults]="getScaleResultItems(item.data.scaleResults)">
                    </dac-summary-section-graph-item>
                </div>
                <div *ngIf="section.template == 'three-graph'" class="row mb-3 mb-print-0 section section-three-graph" [ngClass]="getPrintClasses(section)">
                    <div class="col-12">
                        <div class="row">
                            <dac-summary-section-graph-item *ngFor="let item of section.components; let last = last;" [ngClass]="{'col-6': !last, 'col-12 mt-md-3 mt-print-0': last}"
                                [item]="item" [assessmentResult]="getAssessmentResult(item.data.assessmentUid)" [scaleResults]="getScaleResultItems(item.data.scaleResults)">
                            </dac-summary-section-graph-item>
                        </div>
                    </div>
                </div>
                <!-- one-column-table -->
                <div *ngIf="section.template == 'one-column-table'" class="row mb-3  section section-one-column-table" [ngClass]="getPrintClasses(section)">
                    <div class="col-12">
                        <div class="row">
                            <div class="col-12">
                                <div class="card card-cascade">
                                    <div class="view gradient-card-header secondary-gradient white-text mt-0">
                                        <h3 class='h3-responsive text-center'>{{section.title}}</h3>
                                    </div>
                                    <div class="card-body pt-1 pt-md-3">
                                        <div class="row justify-content-center">
                                            <app-summary-scales-chart *ngFor="let item of section.components" class="col chart" [ngClass]="getChartClasses(item)" [showNames]="item.data.showNames"
                                                [scaleResults]="getScaleResultItems(item.data.scaleResults)" [chartScaleNames]="item.data.chartScaleNames"
                                                [showRangeScore]="item.data.showRangeScore"
                                                [chartRangeNames]="item.data.chartRangeNames" [reverseDirection]="item.data.reverseDirection"></app-summary-scales-chart>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <app-scale-results-table-summary class="col" [scaleResults]="getScaleResultItems(section.tableComponent.data.scaleResults)"
                                [highlightScaleResults]="getScaleResultItems(section.tableComponent.data.highlightScaleResults)"></app-scale-results-table-summary>
                        </div>
                    </div>
                </div>
                <!-- two-column-table -->
                <div *ngIf="section.template == 'two-column-table'" class="row mb-3  section section-two-column-table" [ngClass]="getPrintClasses(section)">
                    <div class="col-12">
                        <div class="row">
                            <div class="col-6" *ngFor="let item of section.components">
                                <div class="card card-cascade h-100">
                                    <div class="view gradient-card-header secondary-gradient white-text">
                                        <h3 class='h3-responsive text-center'>{{item.title}}</h3>
                                    </div>
                                    <div class="card-body pt-1 pt-md-3">
                                        <div class="row">
                                            <app-summary-scales-chart class="col chart" [ngClass]="getChartClasses(item)" [showNames]="item.data.showNames" [scaleResults]="getScaleResultItems(item.data.scaleResults)"
                                                [chartScaleNames]="item.data.chartScaleNames" [chartRangeNames]="item.data.chartRangeNames"
                                                [showRangeScore]="item.data.showRangeScore"
                                                [reverseDirection]="item.data.reverseDirection"></app-summary-scales-chart>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="row">
                            <app-scale-results-table-summary class="col" [scaleResults]="getScaleResultItems(section.tableComponent.data.scaleResults)"
                                [highlightScaleResults]="getScaleResultItems(section.tableComponent.data.highlightScaleResults)"></app-scale-results-table-summary>
                        </div>
                    </div>
                </div>
                <div *ngIf="section.template == 'table'" class="row mb-3 section section-table" [ngClass]="getPrintClasses(section)">
                    <div class="col">
                        <div class="card card-cascade">
                            <div class="view gradient-card-header secondary-gradient white-text" *ngIf="section.title">
                                <h3 class='h3-responsive text-center'>{{section.title}}</h3>
                            </div>
                            <div class="card-body pt-1 pt-md-3">
                                <div class="row">
                                    <app-scale-results-table-summary class="col" [scaleResults]="getScaleResultItems(section.tableComponent.data.scaleResults)"
                                        [highlightScaleResults]="getScaleResultItems(section.tableComponent.data.highlightScaleResults)"></app-scale-results-table-summary>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/reports/report-items/scale-results-summary/scale-results-summary.component.html